import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { catchError, Observable, throwError } from 'rxjs';

import { SentryLogger } from '@fcom/core';
import { ConfigService } from '@fcom/core/services/config/config.service';

import { DarksiteFormData } from '../../interfaces/darksite.interface';

export interface DarksiteCaseResponse {
  errorCode?: number | string;
  errorMessage?: string;
  message: string;
}

@Injectable()
export class IncidentUpdatesService {
  private configService = inject(ConfigService);
  private http = inject(HttpClient);
  private sentryLogger = inject(SentryLogger);

  formEnds: WritableSignal<boolean> = signal<boolean>(false);

  public createDarksiteCase(darksiteCase: DarksiteFormData): Observable<DarksiteCaseResponse> {
    const { apiUrl, keyId } = this.configService.cfg.darkSiteForm.incidentUpdates;
    const httpOptions: HttpHeaders = new HttpHeaders({ 'x-api-key': keyId });

    return this.http.post<DarksiteCaseResponse>(apiUrl, darksiteCase, { headers: httpOptions }).pipe(
      catchError((error: unknown): Observable<never> => {
        this.sentryLogger.warn('Error sending darksite request', { error });
        return throwError((): unknown => error);
      })
    );
  }
}
